import { useState, useEffect } from 'react';

const PREFIX = 'tmis_view_';

// Persists a page's table/tiles choice across sessions, keyed per page so
// each master-data screen remembers its own layout independently. Reused by
// ModuleMasterPage, CourseLevelPage, CourseCataloguePage — and any future
// page that adds a ViewToggle, just pass it a new unique pageKey.
export function useViewPreference(pageKey, fallback = 'tiles') {
  const [view, setView] = useState(() => {
    try {
      return localStorage.getItem(PREFIX + pageKey) || fallback;
    } catch {
      return fallback;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(PREFIX + pageKey, view);
    } catch {
      // localStorage unavailable (private browsing, storage full, etc.) — the
      // preference simply won't persist for this session.
    }
  }, [pageKey, view]);

  return [view, setView];
}
